import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Department = () => {
    document.title = "Sənədlərdə şöbə";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ümumi anlayışlar", value: "/common" },
        { name: "Sənədlərdə şöbə", value: "/common/department", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Sənədlərdə şöbə</h2>
                    <p>
                        Şöbələr, anbarda olan məhsulları şöbələrə ayırmaq üçün nəzərdə tutulub. Cavabdehləri müxtəlif şöbələrə bağlamaq olur. Satış zamanı hər
                        bir cavabdeh özünə aid şöbənin məhsullarının satışını icra edə bilər.
                    </p>
                    <img src="/images/common/department.gif" alt="Sənədlərdə şöbə" />
                </article>
            </div>
        </div>
    );
};
